import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indicator-master',
  templateUrl: './indicator-master.component.html',
  styleUrls: ['./indicator-master.component.css']
})
export class IndicatorMasterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
